import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import actions from '../../redux/actions';
import Heading from '../Heading';
import NavButtons from '../NavButtons';
import Sidebar from './Sidebar';
import TeamsList from '../Teams/TeamsList';

class SelectTeam extends Component {
  componentWillMount() {
    this.props.resetTeam();
  }

  handleNext() {
    const { team } = this.props;

    this.props.hideAlert();

    if (team) {
      if (team.teamuser_set && team.teamuser_set.length > 1) {
        this.props.loadMembers(this.props.team.id);
        this.props.router.push('/create/select-agreement');
      } else {
        this.props.alert(
          'error',
          'A team must contain at least 2 people, including yourself.'
        );
      }
    } else {
      this.props.alert('error', 'Please select a team');
    }
  }

  render() {
    return (
      <div className="select-team side">
        <Heading text="Which team did you create this work with?" />
        <div className="content">
          <Sidebar fields={this.props.fields} />
          <div className="main">
            <p className="text-gray">
              Organize your collaborators into a new team or select a team that
              you have already created from the list below:
            </p>
            <TeamsList type="create" />
          </div>
        </div>
        <div className="step-nav">
          <NavButtons
            direction="back"
            prev={() => this.props.router.push('/create/product-props')}
          />
          <NavButtons direction="next" next={() => this.handleNext()} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  fields: state.create.fields,
  team: state.teams.selectedTeam,
});

const mapDispatchToProps = (dispatch) => ({
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
  resetTeam: () => {
    dispatch(actions.selectTeam(null));
  },
  loadMembers: (teamId) => {
    dispatch(actions.getTeamMembers(teamId));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(SelectTeam));



// WEBPACK FOOTER //
// src/components/Create/SelectTeam.jsx